/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'periods';

const classes = {
  controlsBlock: `${PREFIX}-controlsBlock`,
  binaryControlsBlock: `${PREFIX}-binaryControlsBlock`,
  controlsWrapperRounded: `${PREFIX}-controlsWrapperRounded`,
  controlButton: `${PREFIX}-controlButton`,
  controlButtonDisabled: `${PREFIX}-controlButtonDisabled`,
  swipeButton: `${PREFIX}-swipeButton`,
  swipeButtonDisabled: `${PREFIX}-swipeButtonDisabled`,
  controlButtonActive: `${PREFIX}-controlButtonActive`,
  dateButtonIcon: `${PREFIX}-dateButtonIcon`,
  dateButtonIconActive: `${PREFIX}-dateButtonIconActive`,
};

const StyledPeriodBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(4),

  [`& .${classes.controlsBlock}`]: {
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    width: 'max-content',
    display: 'flex',
    gap: '1px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
    },
  },

  [`& .${classes.binaryControlsBlock}`]: {
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    width: 'max-content',
    display: 'flex',
    gap: '1px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  [`& .${classes.controlButton}`]: {
    height: '48px',
    color: theme.palette.figma_surface?.light,
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '16px',
    padding: theme.spacing(0, 4),
    letterSpacing: '0.25px',
    borderRadius: 0,
    background: theme.palette.semantic_dark?.surface.surface1,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  [`& .${classes.swipeButton}`]: {
    height: '48px',
    color: theme.palette.figma_surface?.light,
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '16px',
    padding: theme.spacing(0, 4),
    letterSpacing: '0.25px',
    borderRadius: 0,
    background: theme.palette.semantic_dark?.surface.surface1,

    ['&:nth-of-type(2)']: {
      transform: 'rotate(180deg)',
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  [`& .${classes.swipeButtonDisabled}`]: {
    color: `${theme.palette.semantic_dark?.disabled.disabled}`,
    background: `${theme.palette.figma_gray_dark_1?.main}`,
  },

  [`& .${classes.controlButtonDisabled}`]: {
    color: `${theme.palette.semantic_dark?.disabled.disabled}`,
    background: `${theme.palette.figma_gray_dark_1?.main}`,
  },

  [`& .${classes.controlButtonActive}`]: {
    color: theme.palette.semantic_dark?.primary.on,
    background: theme.palette.semantic_dark?.primary.main,
  },

  [`& .${classes.dateButtonIcon}`]: {
    fontSize: '16px',
    color: theme.palette.figma_surface?.light,
    margin: theme.spacing(0, 2.5, 0.5, 0),
  },

  [`& .${classes.dateButtonIconActive}`]: {
    color: theme.palette.semantic_dark?.primary.on,
  },
}));

const HintText = styled(Box)(({theme}) => ({
  width: '160px',
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export {classes as periodClasses, StyledPeriodBox, HintText};
